export const RQ_GET_MTP_REPORTS_API = {
  url:'reports/web/effort/mtp/<%= locationId %>/<%= fromYearMonthDate %>/<%= toYearMonthDate %>',
  method:'GET',
  auth:true,
};

export const RQ_GET_DATE_FILTER_API = {
  url:'mtpcyclemaster/list/<%= userId %>',
  method:'GET',
  auth:true,
};

export const RQ_GET_SALON_MTP_LIST_FOR_MONTH = {
  url:'approvals/salonMTPList/<%= managerId %>/<%= fromDate %>/<%= toDate %>',
  method:'GET',
  auth:true,
};

export const RQ_GET_SALON_MTP_DETAILS = {
  url:'approvals/salonMTPDetail/<%= mtpId %>',
  method:'GET',
  auth:true,
};

export const RQ_TOURPLAN_APPROVE_API = {
  url: 'monthlyplan/approval/<%= mtpId %>/approved',
  method: 'PUT',
  auth: true,
};
